import {
    ChangeDetectionStrategy,
    Component,
    HostBinding,
    Inject,
    Input,
} from '@angular/core'
import { Clipboard } from '@angular/cdk/clipboard'
import {
    CompleteOnDestroy,
    DestroyEvent,
    EmitOnDestroy,
    StatefulSubject,
} from '@typeheim/fire-rx'
import { Api } from '@undock/api'
import { SnackbarManager, SnackbarPosition } from '@undock/common/ui-kit/services/snackbar.manager'
import { SessionStorage } from '@undock/core'
import {
    Subscription,
    takeUntil,
} from 'rxjs'
import {
    BriefsManager,
    BriefsStoreState,
} from '@undock/dashboard/services/briefs.manager'
import { CurrentUser } from '@undock/session'
import { CalendarGridViewModel } from '@undock/common/calendar-grid/view-models/calendar-grid.view-model'


@Component({
    selector:'calendar-briefs',
    templateUrl:'calendar-briefs.component.html',
    styleUrls:['calendar-briefs.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CalendarBriefsComponent {

    private _subscription: Subscription

    @HostBinding('class.hidden') isHidden = false

    @CompleteOnDestroy()
    public readonly viewDate$ = new StatefulSubject<Date>()

    @EmitOnDestroy()
    protected readonly destroyEvent = new DestroyEvent()

    @Input() set viewDate(value: Date) {
        this.viewDate$.next(value)
    }

    public readonly briefsState: BriefsStoreState

    public constructor (
        protected api: Api,
        protected clipboard: Clipboard,
        protected currentUser: CurrentUser,
        protected briefsManager: BriefsManager,
        protected sessionStorage: SessionStorage,
        protected snackbarManager: SnackbarManager,
    ) {
        this.briefsState = briefsManager.state
    }

    async ngOnInit() {
        if (!(await this.briefsHasBeenClosed())) {
            this.subscribeForCurrentViewDate()
        } else {
            this.isHidden = true
        }
    }

    protected subscribeForCurrentViewDate() {
        this._subscription = this.viewDate$.pipe(
            takeUntil(this.destroyEvent),
        ).subscribe(date => this.briefsManager.getBriefSummaryForDate(date))
    }

    public copyTextToClipboard(items: string[]) {

        let fullText = ``
        for (let text of items) {
            fullText += `${text}

`
        }

        this.clipboard.copy(fullText)
        this.snackbarManager.info("Copied to clipboard", SnackbarPosition.BottomCenter)
    }

    public async closeBriefs() {
        let user = await this.currentUser.dataStream
        this.sessionStorage.setItem(`@undock[IsBriefsForceClosed][${user._id}]`, 'true')
        this.isHidden = true

        if (this._subscription) {
            this._subscription.unsubscribe()
        }
    }

    // Returns true if the X button has been closed during the user's session.
    public async briefsHasBeenClosed(): Promise<boolean> {
        let user = await this.currentUser.dataStream
        let isBriefsForceClosed = this.sessionStorage.getItem(`@undock[IsBriefsForceClosed][${user._id}]`)
        return isBriefsForceClosed === 'true'
    }
}
